import { fmt } from "../../data/mockData";

export default function TransactionRow({ tx }) {
  const isPos = tx.amount > 0;

  return (
    <div style={{ display: "flex", alignItems: "center", padding: "14px 0", borderBottom: "1px solid var(--border)", gap: "14px" }}>
      <div style={{
        width: "40px", height: "40px", borderRadius: "12px",
        background: "var(--bg-surface)", display: "flex", alignItems: "center",
        justifyContent: "center", fontSize: "18px", flexShrink: 0,
        border: "1px solid var(--border-strong)",
      }}>
        {tx.icon}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: "14px", color: "var(--text-secondary)", fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {tx.merchant}
        </div>
        <div style={{ fontSize: "11px", color: "var(--text-secondary)", fontFamily: "'JetBrains Mono', monospace", marginTop: "2px" }}>
          {tx.category} · {tx.account}
        </div>
      </div>

      <div style={{ textAlign: "right", flexShrink: 0 }}>
        <div style={{ fontSize: "15px", fontFamily: "'Capsule Sans', sans-serif", fontWeight: "600", color: isPos ? "#52D68A" : "var(--text-primary)" }}>
          {isPos ? "+" : ""}{fmt(tx.amount)}
        </div>
        <div style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "'JetBrains Mono', monospace", marginTop: "2px" }}>{tx.date}</div>
      </div>
    </div>
  );
}
